import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared';
import { SponsorDashboardModule } from '../sponsor-dashboard/sponsor-dashboard.module';
import { GeneralCategoriesResolver } from './general-categories-resolver';
import { HeaderTitleModule } from '../header-title/header-title.module';
import { NotificationBarModule } from '../notification-bar';
import { LayoutModule } from '../layout';
import { DashboardContainerComponent } from './dashboard-container.component';
import { CategoriesStorage } from '../documents';
import { AdminDashboardModule } from '../admin-dashboard/admin-dashboard.module';
import { InvestigatorDashboardModule } from '../investigator-dashboard/investigator-dashboard.module';
import { UserSettingsAccessGuard } from './user-settings-access-guard';

@NgModule({
    declarations: [
        DashboardContainerComponent,
    ],
    imports: [
        SharedModule,
        ReactiveFormsModule,
        HeaderTitleModule,
        NotificationBarModule,
        LayoutModule,
        SponsorDashboardModule,
        AdminDashboardModule,
        InvestigatorDashboardModule,
    ],
    providers: [
        CategoriesStorage,
        GeneralCategoriesResolver,
        UserSettingsAccessGuard
    ]
})
export class DashboardModule { }